<form [formGroup]="formGroup">
  <hero-datepicker formControlName="dates"
    [range]="true"></hero-datepicker>
</form>